import React, { useEffect, useState } from "react";
import FormEditHistoryListContainer from "../containers/FormEditHistoryListContainer";
import FormEditService from "../services/formEditService";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const FormEdits = () => {
  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    formEdits: [],
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const getPageInfo = async () => {
    setIsDataLoaded(true);
    const res = await FormEditService.getAllDraftFormEdits();
    setIsDataLoaded(false);
    setScreenInfo({
      ...screenInfo,
      formEdits: res.data,
    });
  };
  useEffect(() => {
    getPageInfo();
  }, []);
  return (
    <div>
      <h1 style={{ textAlign: "center" }}>Edit History</h1>
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && <FormEditHistoryListContainer formEdits={screenInfo.formEdits} getPageInfo={getPageInfo} />}
    </div>
  );
};

export default FormEdits;
